module.exports = __webpack_public_path__ + "static/media/mgDiagram.0df70f6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Images/mgDiagram.png
// module id = 931
// module chunks = 0